import { render, staticRenderFns } from "./screenAudio.vue?vue&type=template&id=2ab09604&scoped=true&"
import script from "./screenAudio.vue?vue&type=script&lang=js&"
export * from "./screenAudio.vue?vue&type=script&lang=js&"
import style0 from "./screenAudio.vue?vue&type=style&index=0&id=2ab09604&scoped=true&lang=css&"
import style1 from "./screenAudio.vue?vue&type=style&index=1&id=2ab09604&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab09604",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab09604')) {
      api.createRecord('2ab09604', component.options)
    } else {
      api.reload('2ab09604', component.options)
    }
    module.hot.accept("./screenAudio.vue?vue&type=template&id=2ab09604&scoped=true&", function () {
      api.rerender('2ab09604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/screenAudio.vue"
export default component.exports